import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Search, X } from "react-bootstrap-icons";

export interface SearchInputUIProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  onClear: () => void;
}

export const SearchInputUI: React.FC<SearchInputUIProps> = ({
  value,
  placeholder = "Поиск...",
  onChange,
  onSearch,
  onClear,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch?.();
    }
  };

  return (
    <InputGroup className="mb-2">
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className="rounded-start-pill"
        style={{ borderRight: "none" }}
      />

      {value && (
        <InputGroup.Text
          onClick={onClear}
          style={{ cursor: "pointer" }}
          className="rounded-end-pill"
        >
          <X />
        </InputGroup.Text>
      )}

      {!value && (
        <InputGroup.Text
          onClick={onSearch && onSearch}
          style={{ backgroundColor: "transparent", borderLeft: "none" }}
          className="rounded-end-pill"
        >
          <Search />
        </InputGroup.Text>
      )}
    </InputGroup>
  );
};
